/**
 * Standard format for displaying dates in app.
 * @param {Date} date
 */
export function getDateString(date: Date) {
    return date.toLocaleDateString(undefined, {
        weekday: 'long',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    });
}
